import React from 'react';

/**
 * Generic unbranded 404 page - shown when the URL doesn't match any
 * known tenant slug. No tenant header / footer / theme is applied.
 */
const GenericNotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-16 text-center">
      {/* Simple logo-like badge */}
      <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mb-6">
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>

      {/* 404 number */}
      <div className="text-[80px] font-extrabold leading-none text-gray-300 select-none">
        404
      </div>

      {/* Title */}
      <h1 className="mt-4 text-lg font-bold text-gray-700 max-w-sm">
        Oops, we can&apos;t seem to find the page you are looking for
      </h1>
    </div>
  );
};

export default GenericNotFound;
